import { SubscribeScreens } from '@/components/subscribe/SubscribeContextProvider/types';

export const subscribeScreens: SubscribeScreens = {
	account: {
		componentName: 'AccountScreen',
	},
	payment: {
		componentName: 'PaymentFormScreen',
	},
};
